import { Flex, Text } from 'rebass';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toggleNewStoryVisible } from 'stories/actions';
import { IoMdAddCircleOutline } from "react-icons/io";
import { useCurrentMember } from 'members/hooks/index';

const NewStoryTag = ({ canCreateAnotherStory, childJournal, canCreateStory, openFtueFlow }) => {
  const member = useCurrentMember();

  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    if (canCreateAnotherStory) {
      dispatch(toggleNewStoryVisible());
    } else
      openFtueFlow()
  }, [canCreateAnotherStory, dispatch]);

  if (canCreateStory === null)
    return <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      color="mutedText"
      minHeight={250}
      sx={{
        borderRadius: '12px',
        border: '1px dashed #9B59B6',
        background: '#F5EEF8',
        cursor: 'pointer'
      }}
    />

  if (canCreateAnotherStory === false)
    return <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      color="mutedText"
      minHeight={250}
      p={1}
      sx={{
        borderRadius: '12px',
        border: '1px dashed #9B59B6',
        background: '#F5EEF8',
        cursor: 'pointer'
      }}
      onClick={() => {
        window.open(childJournal?.['bundle-purchase-url'] + `?email=${encodeURIComponent(member?.email)}`, '_blank')
      }}
    >
      <Text fontSize="16px" color="rgba(0, 0, 0, 0.85)" textAlign="center" lineHeight="24px" mt={2} >
        Upgrade account to add new memories
      </Text>
    </Flex>
  else
    return (
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        color="mutedText"
        minHeight={250}
        sx={{
          borderRadius: '12px',
          border: '1px dashed #9B59B6',
          background: '#F5EEF8',
          cursor: 'pointer'
        }}
        onClick={onClick}
      >
        <IoMdAddCircleOutline color="black" size={24} />
        <Text fontSize="16px" color="rgba(0, 0, 0, 0.85)" textAlign="center" lineHeight="24px" mt={2} >
          Add a New Story
        </Text>
      </Flex>
    )

};

export default NewStoryTag;
